
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/detail",
      function () {
        return require("private-next-pages/events/detail.tsx");
      }
    ]);
  